// extracted by mini-css-extract-plugin
module.exports = {"input__wrapper":"da51a739f7--input__wrapper--TlUdH","input__wrapper--m":"da51a739f7--input__wrapper--m--O1GIa"};